import { useContext } from 'react'
import { EditPanelContext } from '../contexts/panel'
import { Divider } from '../style'
import Fields from './fields'
import Labels from './labels'
import { AdditionalFields, Preview, Split } from './style'
import Tags from './tags'

type Props = {
    className?: string
}

const EditPanelInfo = ({ className }: Props) => {
    const { colors, gifIds, isCompact } = useContext(EditPanelContext)

    return (
        <div className={className}>
            <Split $compact={isCompact}>
                <Preview />
                <Fields />
            </Split>
            <Divider $color={colors.divider} />
            <AdditionalFields>
                <Tags />
                <Labels key={gifIds.join(',')} />
            </AdditionalFields>
        </div>
    )
}

export default EditPanelInfo
